module.exports = __webpack_public_path__ + "static/media/29BDOS19.cebdcb87.jpg";